/* Routes for the servers area (Area A: servers and onboarding). Paths are relative; see src/app/routes.ts. */
import { page, type AreaRoutes } from '@/app/routes'

export const routes: AreaRoutes = {
  shell: [
    { path: 'servers', lazy: page(() => import('./pages/ServersPage')) },
    { path: 'servers/:id/*', lazy: page(() => import('./pages/ServerPage')) },
  ],
  focus: [{ path: 'servers/new', lazy: page(() => import('./pages/AddServerPage')) }],
}
